import ContactForm from "../components/ContactForm";

function CF() {

  return (

    <div style={{width:"500px",margin:"50px auto"}}>

      <ContactForm />

    </div>

  );

}

export default CF;